import Vue from 'vue';
import Router from 'vue-router';
import ContentManage from '@/router/module/content-manage';

const Login = () => import('@/pages/Login');
const Index = () => import('@/pages/Index');
Vue.use(Router);

const children = [
  ...ContentManage,
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      redirect: '/login',
    },
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/index',
      component: Index,
      children,
    }
  ],
});

export default router;
